import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { AssetTranscriptionsAppState } from './types';

const initialState: AssetTranscriptionsAppState = {
  selectedTranscriptionPropertiesIdByAssetId: {},
  speakerMode: true,
};

export const assetTranscriptionsSlice = createSlice({
  name: 'asset_transcriptions',
  initialState,
  reducers: {
    setSelectedTranscriptionPropertiesId: (
      state,
      action: PayloadAction<{
        assetId: string;
        propertiesId: string | undefined;
      }>,
    ) => {
      state.selectedTranscriptionPropertiesIdByAssetId[action.payload.assetId] =
        action.payload.propertiesId;
    },

    setSpeakerMode: (state, action: PayloadAction<boolean>) => {
      state.speakerMode = action.payload;
    },
  },
});

export const { setSelectedTranscriptionPropertiesId, setSpeakerMode } =
  assetTranscriptionsSlice.actions;

export const assetTranscriptions = assetTranscriptionsSlice.reducer;
